import { createContext } from "react";

/**
 * Lists supported layout preference values without selecting a layout.
 */
export enum ApplicationLayoutMode {
    Legacy = "legacy",
    Modern = "modern"
}

/**
 * Lists supported theme preference values.
 */
export enum ApplicationTheme {
    Light = "light",
    Dark = "dark"
}

/**
 * Holds the user's layout and theme selections.
 */
export interface IUserPreferences {
    layout: ApplicationLayoutMode;
    theme: ApplicationTheme;
}

/**
 * Exposes current preferences and provider-owned update controls.
 */
export interface IUserPreferencesContext {
    preferences: IUserPreferences;
    setPreferences: (preferences: IUserPreferences) => void;
    toggleTheme: () => void;
}

/**
 * Supplies the shared legacy-layout and light-theme defaults.
 */
export const defaultUserPreferences: IUserPreferences = {
    layout: ApplicationLayoutMode.Legacy,
    theme: ApplicationTheme.Light
};

/**
 * Provides preferences with inert default update controls when no provider is present.
 *
 * Postconditions: Defaults use legacy layout and light theme. Default setters do nothing;
 * persistence and actual theme updates belong to a provider.
 */
export const UserPreferencesContext = createContext<IUserPreferencesContext>({
    preferences: defaultUserPreferences,
    setPreferences: () => undefined,
    toggleTheme: () => undefined
});

export default UserPreferencesContext;
